import PropTypes from 'prop-types';
import React from 'react';

import ActivitySettingsForm from './ActivitySettingsForm';

const ActivitySettingsTableHead = ({
  headerGroups,
  handleCreateItem
}) => {
  return (
    <thead>
      {headerGroups.map((headerGroup, index) => (
        <React.Fragment key={index}>
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column, cIndex) => (
              <th key={cIndex * 123} scope="col" {...column.getHeaderProps(column.getSortByToggleProps())}>
                {column.render('Header')}
                <span>
                  {column.isSorted
                    ? column.isSortedDesc
                      ? ' 🔽'
                      : ' 🔼'
                    : ''}
                </span>
              </th>
            ))}
          </tr>
          <ActivitySettingsForm headerGroup={headerGroup} handleCreateItem={handleCreateItem} />
        </React.Fragment>
      ))}
    </thead>
  );
};

ActivitySettingsTableHead.propTypes = {
  headerGroups: PropTypes.array.isRequired,
  handleCreateItem: PropTypes.func.isRequired
};

export default ActivitySettingsTableHead;
